import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a34bc32e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toggle-switch" }
const _hoisted_2 = ["id", "disabled"]
const _hoisted_3 = { class: "outline" }
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "toggle-switch-inner" }
const _hoisted_6 = { class: "toggle-switch-active" }
const _hoisted_7 = { class: "toggle-switch-inactive" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "toggle-switch-handle" }, null, -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      name: "toggle-switch",
      class: "toggle-switch-checkbox",
      id: _ctx.id,
      tabindex: "0",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.newState) = $event)),
      onChange: _cache[1] || (_cache[1] = $event => (_ctx.changeState())),
      disabled: _ctx.disabled
    }, null, 40, _hoisted_2), [
      [_vModelCheckbox, _ctx.newState]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", {
        class: "toggle-switch-label",
        for: _ctx.id
      }, [
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.activeText), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.inactiveText), 1)
        ]),
        _hoisted_8
      ], 8, _hoisted_4)
    ])
  ]))
}